import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash";

// import ChargeDetails from './ChargeDetails';
import Pagination from '../../../container/MUI/Pagination';
import { MoreVertRounded, FilterListRounded } from '@mui/icons-material';

import { 
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button, 
    Box,
    TableContainer,
    IconButton,
    Menu,
    MenuItem,
    Checkbox,
    
} from '@mui/material';

import { EnhancedTableHead, EnhancedTableToolbar } from '../../../container/MUI/EnhancedTable';
import ChargePaymentForm from '../Payments/ChargePaymentForm';
import FilterSalaries from './FilterSalaries';
import PaymentForm from '../Payments/PaymentFormAll';
import PaymentUserForm from '../Payments/PaymentUserForm';
import ChargePaymentUserForm from '../Payments/ChargePaymentUserForm';
import { MONTHS } from '../../../utils/generalFuncs';

class ChargesList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,
        openDetails: false,
        charge: {},
        anchorEl: null, 
        openMenu: "", 
        checkedItems: [],

    }
    componentWillMount() {
        window.scrollTo(0, 0);
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };
    handleChange = (e) => {
        this.setState({
            checkedItems :[],
            page: 0,
        })
        this.props.handleChange(e)

    }
    handleChange = (e) => {
        this.setState({
            checkedItems :[],
            page: 0,
        })
        this.props.handleChange(e)

    }
    handleChangeEmployee = (option) => {
        this.setState({                
            checkedItems :[],
            page: 0,
        })
        this.props.handleChangeEmployee(option)
    }
    handleSelect = (option, name) => {
        this.setState({                
            checkedItems :[],
            page: 0,
        })
        this.props.handleSelect(option, name)
    }
    handleChangeCat = (option) => {
        this.setState({                
            checkedItems :[],
            page: 0,
        })
        this.props.handleChangeCat(option)
    }
    filterList = () => {
        const { searchEmployee, searchMonth, searchYear, pay_status, searchCat, CHARGES, SALARIES } = this.props
        
        let filteredList = Object.values(CHARGES)
        if( !isEmpty(pay_status)) {
            filteredList = filteredList.filter( item => item.salary_line_status === pay_status)
        }
        
        if( !isEmpty(searchEmployee.value)) {
            filteredList = filteredList.filter( item => item.salary_line_employee === searchEmployee.value)
        } else if( Array.isArray(searchEmployee) && !isEmpty(searchEmployee) ) {
            let itemList = searchEmployee.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.salary_line_employee))
        }

        if( !isEmpty(searchMonth.value) ) {
            filteredList = filteredList.filter( item => new Date(SALARIES[item.salary_id].salary_period_start).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth) ) {
            let itemList = searchMonth.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(SALARIES[item.salary_id].salary_period_start).getMonth()))
        }

        if( searchYear ) {
            filteredList = filteredList.filter( item => new Date(SALARIES[item.salary_id].salary_period_start).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) && !isEmpty(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(SALARIES[item.salary_id].salary_period_start).getFullYear()))
        }

        if( !isEmpty(searchCat.value) ) {
            filteredList = filteredList.filter( item => item.salary_line_name === searchCat.value)
        } else if( Array.isArray(searchCat) && !isEmpty(searchCat) ) {
            let catList = searchCat.map(cat => cat.value )
            filteredList = filteredList.filter( item => catList.includes(item.salary_line_name))
        }

        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        return filteredList
    }
    displayList = () => {
        const { CHARGES, EMPLOYEES, SALARY_CATS } = this.props;
        let tab = []
        let rows = 0
        let maxSelect = 0
        if (!isEmpty(CHARGES) && !isEmpty(EMPLOYEES) && !isEmpty(SALARY_CATS) ){
            let filteredList = this.filterList()
            rows = size(filteredList)
            tab.push( this.getChargeList(filteredList))
            maxSelect = size(filteredList.filter( item => item.salary_line_status === "WAITING"))
        }
        return [tab, rows, maxSelect]
    }
    getChargeList = (list) => {
        const { CHARGES, EMPLOYEES, SALARY_CATS, SALARIES } = this.props
        const { rowsPerPage, page, openMenu, anchorEl, checkedItems } = this.state;
        const isSelected = name => checkedItems.indexOf(name) !== -1;

        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( (item, index) => {

            let isItemSelected = isSelected(item.salary_line_id)
            const labelId = `enhanced-table-checkbox-${index}`;

            return (
                <TableRow hover key={item.salary_line_id} className="clickable"
                    title="Voir le Détail"
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={ isItemSelected }
                >
                    <TableCell 
                        padding="checkbox"
                    >
                    {!item.salary_line_fully_paid &&
                        <Checkbox
                            onClick={event => this.handleClick(event, item.salary_line_id)}
                            disabled={item.salary_line_fully_paid}
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    }
                    </TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {MONTHS[new Date(SALARIES[item.salary_id].salary_period_end).getMonth()]} {new Date(SALARIES[item.salary_id].salary_period_start).getFullYear()}</TableCell>
                    {/* <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {new Date(item.salary_line_date).toLocaleDateString('fr-FR')}</TableCell> */}
                    
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {item.salary_line_name && SALARY_CATS[item.salary_line_name].salary_cat_name} - {item.salary_line_employee && EMPLOYEES[item.salary_line_employee].employee_lastname} {item.salary_line_employee && EMPLOYEES[item.salary_line_employee].employee_firstname}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {item.salary_line_retenue}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {item.salary_line_rest_to_pay}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, charge: item })}
                    > {item.salary_line_status}</TableCell>
                    <TableCell>
                        {!item.salary_line_fully_paid &&
                            <Fragment>
                                <IconButton 
                                    aria-controls={`option-menu${item.salary_line_id}`} 
                                    aria-haspopup="true"
                                    onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.salary_line_id}) }>
                                    <MoreVertRounded/>
                                </IconButton>

                                <Menu
                                    id={`option-menu${item.salary_line_id}`}
                                    anchorEl={anchorEl}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={ openMenu === item.salary_line_id}
                                    onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                >
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPayment: true, 
                                            singlePayment: [item.salary_line_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement
                                    </MenuItem>
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPaymentUser: true, 
                                            singlePayment: [item.salary_line_id], 
                                            employee: item.salary_line_employee, 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement Collaborateur
                                    </MenuItem>
                            </Menu>
                        </Fragment>
                        }
                    </TableCell>
                </TableRow>
            ) }
        )
        
    }

    handleClick = (event, name) => {
        const { checkedItems } = this.state;
        const selectedIndex = checkedItems.indexOf(name);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedItems, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedItems.slice(1));
        } else if (selectedIndex === checkedItems.length - 1) {
            newSelected = newSelected.concat(checkedItems.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedItems.slice(0, selectedIndex),
                checkedItems.slice(selectedIndex + 1),
            );
        }
    
        // console.log('====================================');
        // console.log({newSelected, name, event});
        // console.log('====================================');
        this.setState({
            checkedItems : newSelected
        });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            let filteredList = this.filterList()
            filteredList = filteredList.filter( item => item.salary_line_status === "WAITING")
            const newSelecteds = filteredList.map(item => item.salary_line_id);
            this.setState({
                checkedItems : newSelecteds
            });
          return;
        }
        this.setState({
            checkedItems :[]
        });
        
    };


    handleClose = () => {
		this.setState({ 
            openDetails: false,
            newPaymentUser: false,
            employee: {},
            newPayment: false,
            charge: {},
            openForm: false,
        });
    };    
        
    render() {
        const { CHARGES, SALARY_CATS, EMPLOYEES, openFilters } = this.props;
        const { rowsPerPage, page, openDetails, charge, checkedItems, newPayment, singlePayment, newPaymentUser  } = this.state;
        console.log('==== STATE CHARGES LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let list = this.displayList()
        // let total = 0
        // if(!isEmpty(checkedItems) ){
        //     checkedItems.forEach(ID => total += CHARGES[ID].salary_line_rest_to_pay)
        // }
        return (
               
            <Box>
                <Typography variant="h6" id="tableTitle">
                    Liste des Charges
                </Typography>
                
                 {newPayment && !isEmpty(checkedItems) &&
                    <PaymentForm
                    // <ChargePaymentForm
                        charges={checkedItems}
                        handleClose={() => this.setState({ newPayment: false, checkedItems:[] })}
                        notif={this.notif}
                        // total={total}
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(singlePayment) &&
                    <ChargePaymentForm
                        charges={singlePayment }
                        handleClose={() => this.setState({ newPayment: false, singlePayment: [] })}
                        notif={this.notif}
                        {...this.props}
                    />
                }
                {newPaymentUser && !isEmpty(singlePayment) && !isEmpty(this.state.employee) && 
                    <ChargePaymentUserForm
                        charges={singlePayment }
                        employee={this.state.employee}
                        handleClose={() => this.setState({ newPaymentUser: false, singlePayment: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }

                <Box p={2}>
                    <Button 
                        variant="outlined" 
                        color="secondary"
                        onClick={this.props.handleOpenFilters}
                        startIcon={<FilterListRounded />}
                    >
                        Filtres
                    </Button>
                </Box>

                {openFilters && 
                    <FilterSalaries
                        EMPLOYEES={EMPLOYEES}
                        SALARY_CATS={SALARY_CATS}
                        handleChange={this.handleChange}
                        handleChangeEmployee={this.handleChangeEmployee}
                        handleChangeCat={this.handleChangeCat}
                        handleSelect={this.handleSelect}
                        charges
                        searchMonth={this.props.searchMonth}
                        searchYear={this.props.searchYear}
                        pay_status={this.props.pay_status}
                        searchEmployee={this.props.searchEmployee}
                        searchCat={this.props.searchCat} 
                    />
                }

                {!isEmpty(checkedItems) &&
                    <EnhancedTableToolbar 
                        numSelected={size(checkedItems)} 
                        action={() => this.setState({ newPayment: true })}
                    />
                }
                {!isEmpty(CHARGES) && 
                    <TableContainer>
                        <Table>
                            <EnhancedTableHead
                                numSelected={size(checkedItems)}
                                onSelectAllClick={this.handleSelectAllClick}
                                rowCount={list[2]}
                                headers={[
                                    { id: 'salary_line_date', numeric: false, disablePadding: false, label: 'Créé le' },
                                    { id: 'salary_line_desc', numeric: false, disablePadding: false, label: 'Libellé' },
                                    { id: 'salary_line_retenue', numeric: true, disablePadding: false, label: 'Montant' },
                                    { id: 'salary_line_rest_to_pay', numeric: true, disablePadding: false, label: 'Reste à Payer' },
                                    { id: 'salary_line_status', numeric: false, disablePadding: false, label: 'Statut' },
                                    { id: 'options', numeric: false, disablePadding: false, label: 'Options' },
                                ]}
                            />
                            <TableBody>
                                {list[0]}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[20, 30]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={7}
                                        count={list[1]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table> 
                    </TableContainer>
                }
            </Box>
        );
    }
}

export default ChargesList;